import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const ResetPasswordDialog = ({ state, onChange, onClose, onConfirm }) => {
  return (
    <Dialog open={state.open} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Reset Password</DialogTitle>
          <DialogDescription>
            Set a new password for <strong>{state.user?.name}</strong> ({state.user?.email})
          </DialogDescription>
        </DialogHeader>
        <Input
          type="text"
          value={state.newPassword}
          onChange={(e) => onChange({ ...state, newPassword: e.target.value })}
          placeholder="Enter new password"
          className="font-mono"
          data-testid="reset-password-input"
          autoFocus
        />
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>Cancel</Button>
          <Button
            onClick={onConfirm}
            disabled={state.newPassword.length < 4}
            data-testid="reset-password-confirm"
          >
            Reset Password
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
